import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { useProductContext } from "../context";
import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";
import { SearchUsers } from "components/SearchSelect/SearchUsers";
import { Button } from "@mui/material";
import { taskDocId } from "constants/documentCode";
import { useState } from "react";
import { useGlobalContext } from "context/GlobalContext";
import { STATUS_CODES } from "constants/responses/statusCodes";
import dayjs from "configs/dayjs.config";

import { addTaskForProductApi } from "API/apis/product/addTaskForProduct";
import { useNavigate } from "react-router-dom";
import { routeLinks } from "constants/paths";
import { DatePickerWrapper } from "components/DateTimePicker/DatePicker";

const initialUserDetail = {
  name: "",
  dept: "",
  subDept: "",
  userId: "",
};

const initialState = {
  docType: taskDocId.enquiry,
  docId: 0,
  taskDetails: "",
  alertBeforeDays: null,
  deadline: null,
  taskTo: { ...initialUserDetail },
  companyId: 0,
  docDetails: "",
};

export const TaskFormSubjective = () => {
  const [formData, setFormData] = useState(initialState);
  const { productsSelectedForTask, currentProject } = useProductContext();
  const { setIsLoading, setSuccess, setError } = useGlobalContext();

  const [selectedTaskByUser, setSelectedTaskByUser] =
    useState(initialUserDetail);
  const [selectedTaskToUser, setSelectedTaskToUser] =
    useState(initialUserDetail);

  const navigate = useNavigate();

  const handleDeliveryDateChange = (newValue) => {
    if (newValue) {
      setFormData({
        ...formData,
        deadline: newValue.toDate(),
      });
    }
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      docType: taskDocId.enquiry,
      docId: productsSelectedForTask,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddTaskUserSubmit = async (e) => {
    e.preventDefault();
    try {
      if (dayjs().subtract(1, "day") > formData.deadline) {
        throw new Error("Older dates are not allowed");
      }

      setIsLoading(true);
      const { data, status } = await addTaskForProductApi({
        ...formData,
        taskTo: selectedTaskToUser?.userId || "",
        taskBy: selectedTaskByUser?.userId || "",
        docType: productsSelectedForTask.map((item) =>
          item.isCatalogued ? 5 : 4
        ),
        docDetails: productsSelectedForTask.map(
          (item) =>
            item.clientCode +
            " - " +
            item.clientName +
            " | " +
            item.docCode +
            " - " +
            item.productName +
            " - " +
            item.productQuantity +
            " " +
            item.productUom
        ),
        docId: productsSelectedForTask.map((item) => item.lotPartId),
        docCode: productsSelectedForTask.map((item) => item.partLotDocCode),
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setFormData(initialState);
      setSuccess(data?.message);
      setIsLoading(false);
      navigate(routeLinks.projectManagementProject + "/" + currentProject);
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    }
  };

  return (
    <form onSubmit={handleAddTaskUserSubmit}>
      <TextFieldWrapper
        multiline
        id="taskDetails"
        name="taskDetails"
        label="Task Detail"
        variant="outlined"
        value={formData.taskDetails}
        fullWidth
        required
        onChange={handleChange}
      />
      <TextFieldWrapper
        multiline
        id="taskDescription"
        name="taskDescription"
        label="Task Description"
        variant="outlined"
        value={formData.taskDescription}
        rows={5}
        fullWidth
        required
        onChange={handleChange}
      />
      <FormControlWrapper fullWidth>
        <SearchUsers
          label="Assign By"
          handleUserSelection={setSelectedTaskByUser}
          selectedUser={selectedTaskByUser}
        />
      </FormControlWrapper>
      <FormControlWrapper fullWidth>
        <SearchUsers
          label="Assign To"
          handleUserSelection={setSelectedTaskToUser}
          selectedUser={selectedTaskToUser}
        />
      </FormControlWrapper>
      <TextFieldWrapper
        id="alertBeforeDays"
        name="alertBeforeDays"
        label="Alert Before Days"
        variant="outlined"
        value={formData.alertBeforeDays}
        fullWidth
        inputProps={{ min: 1 }}
        required
        onChange={handleChange}
      />
      <FormControlWrapper fullWidth>
        <DatePickerWrapper
          label="Delivery Date"
          value={dayjs(formData.deadline)}
          onChange={(newValue) => handleDeliveryDateChange(dayjs(newValue))}
        />
      </FormControlWrapper>
      <Button variant="contained" type="submit" fullWidth>
        Submit
      </Button>
    </form>
  );
};
